module.exports = __webpack_public_path__ + "img/card_changes-icon.7403408d.svg";